<template>
  <mt-popup v-model="visible" position="bottom" class="field-select_popup">
    <div class="select-actions">
      <span class="cannel" @click="selectClose(0)">取消</span>
      <span class="ok" @click="selectClose(1)">确认</span>
    </div>
    <!-- 选择地区 -->
    <div v-if="visible && format === 'area'" class="select-options">
      <my-distpicker
        type="mobile"
        :districts="DISTRICTS"
        :province="area.province"
        :city="area.city"
        :area="area.area"
        @province="value = {}"
        @city="value = {}"
        @selected="onSelected_distpicker"
      />
    </div>
    <!-- 选择列表 -->
    <div v-else class="select-options">
      <template v-if="options && options.slots">
        <mt-picker :slots="options.slots" :valueKey="options.valueKey" @change="onSelected_picker" />
      </template>
    </div>
  </mt-popup>
</template>

<script>
// 地区选择器 #修复‘省直辖县’匹配错误
// import VDistpicker from 'v-distpicker'
import MyDistpicker from './src/VDistpicker'
import DISTRICTS from '@/assets/data/districts.json'

export default {
  name: 'SelectPopup',
  components: { MyDistpicker },
  props: {
    format: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default: () => {}
    },
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      DISTRICTS,
      value: {}
    }
  },
  watch: {
    visible: function (val) {
      if (val) {
        document.documentElement.style.overflow = 'hidden'
      } else {
        document.documentElement.style.overflow = ''
      }
    }
  },
  computed: {
    area() {
      const area = this.text.split(' / ')
      return {
        province: area[0],
        city: area[1],
        area: area[2]
      }
    }
  },
  methods: {
    // 通用选择器
    onSelected_picker(picker, values) {
      const [value] = values
      this.value = value
    },
    // 选择地址器
    onSelected_distpicker(value) {
      this.value = value
    },
    selectClose(status) {
      if (status) {
        const { value, format } = this
        if (!((format === 'area' && value.area && value.area.code) || value)) {
          return
        }
        this.$emit('on-select', { value, format })
        this.visible = !this.visible
      } else {
        this.visible = !this.visible
      }
    }
  }
}
</script>

<style lang="scss">
// 选择元素的弹窗
.field-select_popup {
  width: 100%;
  min-height: 30%;
  display: flex;
  flex-flow: column;
  .select-options {
    flex: 1;
    display: flex;
    flex-flow: column;
    height: 100%;
    // .picker {
    //   height: 100%;
    //   .picker-items {
    //     height: 100%;
    //   }
    // }
    // 日期选择容器
    .distpicker-address-wrapper {
      flex: 1;
      display: flex;
      flex-flow: column;
      height: 100%;
      .address-container {
        overflow: scroll;
      }
    }
  }
}
.select-actions {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  .cannel {
    color: #909399;
  }
  .ok {
    color: #00b25a;
  }
}
.field-select_popup > .mint-popup-bottom {
  top: 50%;
}
</style>
